<template>
  <v-dialog :model-value="isVisible" width="600" @close="$emit('close')">
    <v-card v-if="assetVisit">
      <v-card-title class="d-flex flex-row ma-2">
        <h4 class="text-capitalize" data-testid="yard-asset-visit-depart-dialog-title">
          <v-icon size="small" class="mr-2">mdi-alert-circle-outline</v-icon>
          <span>
            {{ t('yard.dialogs.yardViewAssetVisitDepartDialog.headers.confirmAssetDeparture') }}
          </span>
        </h4>
        <v-spacer></v-spacer>
        <v-btn
          icon="mdi-close"
          variant="text"
          density="comfortable"
          @click="$emit('close')"></v-btn>
      </v-card-title>
      <v-card-text>
        <yard-view-depart-details
          :asset="assetVisit"
          data-testid="yard-asset-visit-depart-dialog-details" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          variant="outlined"
          @click="$emit('close')"
          data-testid="yard-asset-visit-depart-dialog-cancel">
          {{ t('global.buttons.nevermind') }}
        </v-btn>
        <v-btn
          class="bg-primary"
          @click="departAssetVisit"
          data-testid="yard-asset-visit-depart-dialog-submit">
          {{ t('global.buttons.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { AssetVisitEventType } from '@nova/core';
import useYard from '@/modules/yard/composables/useYard';
import YardViewDepartDetails from '@/modules/yard/components/AssetVisit/YardViewDepartDetails.vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewAssetVisitDepartDialog',
  emits: ['close'],
  components: {
    YardViewDepartDetails
  },
  props: {
    assetVisit: {
      type: Object,
      required: true
    },
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const yardStore = useYard();
    const isAssetContainer = computed(() => yardStore.isAssetContainer(props.assetVisit));

    const departAssetVisit = async () => {
      const assetVisit = { ...props.assetVisit };

      const serviceCall = isAssetContainer.value
        ? yardStore.updateAssetContainerStatus
        : yardStore.updateAssetVisitStatus;

      return serviceCall(
        yardStore.selectedAssetVisitRef.value.id,
        AssetVisitEventType.Departed
      ).then(() => {
        yardStore.trackMixpanelEvent(yardStore.MixPanelEvent.DEPART, {
          assetVisit,
          metadata: {
            departed_with_asset_container: Boolean(assetVisit.assetContainerId),
            appointment_id: assetVisit.appointmentId,
            is_asset_container: isAssetContainer.value
          }
        });
        emit('close');
      });
    };

    return {
      departAssetVisit,
      t
    };
  }
});
</script>
